import {Injectable} from '@angular/core';

/**
 * Translations for invoice order statuses.
 */
@Injectable()
export class InvoiceOrderStatusTranslationsService {
  public i18nInvoice: any = $localize`:@@general.status.invoice:Invoice`;
  public i18nCancellation: any = $localize`:@@general.status.cancellation:Cancellation`;
  public i18nReservation: any = $localize`:@@general.status.reservation:Reservation`;
  public i18nDispatched: any = $localize`:@@general.status.dispatched:Dispatched`;
  public i18nPrinted: any = $localize`:@@general.status.printed:Printed`;
  public i18nBooked: any = $localize`:@@general.status.booked:Booked`;
  public i18nBookable: any = $localize`:@@general.status.bookable:Bookable`;
  public i18nExpired: any = $localize`:@@general.status.expired:Expired`;
  public i18nReserved: any = $localize`:@@general.status.reserved:Reserved`;
  public i18nPaid: any = $localize`:@@general.status.paid:Paid`;
  public i18nReturned: any = $localize`:@@general.status.returned:Returned`;
  public i18nCash: any = $localize`:@@general.status.cash:Cash`;
  public i18nCreditCard: any = $localize`:@@general.status.creditCard:Credit Card`;
  public i18nPaypal: any = $localize`:@@general.status.paypal:Paypal`;
  public i18nNoShipping: any = $localize`:@@general.status.noShipping:No shipping`;
  public i18nOption: any = $localize`:@@general.status.option:Option`;
  public i18nCheque: any = $localize`:@@general.status.cheque:Cheque`;
  public i18nTransfer: any = $localize`:@@general.status.transfer:Bank order`;
  public i18nCashOnDelivery: any = $localize`:@@general.status.cashOnDelivery:Cash on delivery`;
  public i18nCashCard: any = $localize`:@@general.status.cashCard:Pay card`;
  public i18nCredit: any = $localize`:@@general.status.credit:Credit`;
  public i18nDoor: any = $localize`:@@general.status.door:Cellection at box office`;
  public i18nFree1: any = $localize`:@@general.status.free1:Internal payment 1`;
  public i18nFree2: any = $localize`:@@general.status.free2:Internal payment 2`;
  public i18nVoucher: any = $localize`:@@general.status.voucher:Voucher`;
  public i18nSepaDirectDebit: any = $localize`:@@general.status.sepaDirectDebit:SEPA direct debit`;
  public i18nCallCenter: any = $localize`:@@general.status.callCenter:Call Center`;
  public i18nTicketAgent: any = $localize`:@@general.status.ticketAgent:Ticket Agent`;
  constructor() { }
}
